/*
 * Delivery Estimate — previsao de entrega regional estilo Mercado Livre.
 * Porte vanilla do componente React DeliveryEstimate.tsx (repo lummi-glow-ups).
 * As regras de prazo, o cutoff de 15h e os textos sao SLA da operacao — nao alterar aqui.
 */
(function () {
  'use strict';

  if (!window.customElements || customElements.get('delivery-estimate')) return;

  var STATE_TO_REGION = {
    SP: 'sudeste', MG: 'sudeste', RJ: 'sudeste', ES: 'sudeste',
    GO: 'sul-co', MT: 'sul-co', MS: 'sul-co', DF: 'sul-co', PR: 'sul-co', SC: 'sul-co', RS: 'sul-co',
    MA: 'nordeste', PI: 'nordeste', BA: 'nordeste', CE: 'nordeste', PE: 'nordeste',
    SE: 'nordeste', AL: 'nordeste', PB: 'nordeste', RN: 'nordeste',
    AC: 'norte', RO: 'norte', AM: 'norte', PA: 'norte', TO: 'norte', AP: 'norte', RR: 'norte'
  };

  var REGION_DELIVERY = {
    'sudeste': [3, 7],
    'sul-co': [5, 10],
    'nordeste': [7, 18],
    'norte': [10, 21]
  };

  // Cutoff diario de processamento: pedidos ate 15h saem no mesmo dia,
  // pedidos apos 15h saem no dia seguinte.
  var CUTOFF_HOUR = 15;
  var CACHE_KEY = 'lummi_geo_region_v1';
  var CACHE_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  var FALLBACK_REGION = 'sudeste';
  var GEO_URL = 'https://ipapi.co/json/';
  var GEO_TIMEOUT_MS = 3000;
  var TICK_MS = 60000;

  var MONTHS_PT = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

  function formatDate(d) {
    return d.getDate() + ' ' + MONTHS_PT[d.getMonth()];
  }

  function formatRange(start, end) {
    if (start.getMonth() === end.getMonth() && start.getDate() !== end.getDate()) {
      return start.getDate() + ' - ' + end.getDate() + ' ' + MONTHS_PT[end.getMonth()];
    }
    if (start.getDate() === end.getDate() && start.getMonth() === end.getMonth()) {
      return formatDate(start);
    }
    return formatDate(start) + ' - ' + formatDate(end);
  }

  function addDays(d, days) {
    var r = new Date(d.getTime());
    r.setDate(r.getDate() + days);
    return r;
  }

  // Countdown ate o proximo cutoff de 15h. Depois das 15h, conta pro dia seguinte.
  function countdown(now) {
    var cutoff = new Date(now.getTime());
    cutoff.setHours(CUTOFF_HOUR, 0, 0, 0);
    var isAfterCutoff = now >= cutoff;
    var target = isAfterCutoff ? addDays(cutoff, 1) : cutoff;
    var diffMs = Math.max(0, target.getTime() - now.getTime());
    var totalMin = Math.floor(diffMs / 60000);
    return {
      hours: Math.floor(totalMin / 60),
      minutes: totalMin % 60,
      isAfterCutoff: isAfterCutoff
    };
  }

  function computeDates(region, now, isAfterCutoff) {
    var span = REGION_DELIVERY[region] || REGION_DELIVERY[FALLBACK_REGION];
    var processingDate = addDays(now, isAfterCutoff ? 1 : 0);
    return {
      today: now,
      processingDate: processingDate,
      deliveryStart: addDays(processingDate, span[0]),
      deliveryEnd: addDays(processingDate, span[1])
    };
  }

  /* ---------- Resolucao de regiao (cache 7d -> geo IP -> fallback sudeste) ---------- */

  var regionPromise = null;

  function readCache() {
    try {
      var cached = localStorage.getItem(CACHE_KEY);
      if (!cached) return null;
      var parsed = JSON.parse(cached);
      if (parsed && parsed.expires > Date.now() && STATE_TO_REGION[parsed.state]) {
        return { region: STATE_TO_REGION[parsed.state], stateCode: parsed.state };
      }
    } catch (e) { /* localStorage indisponivel ou JSON corrompido */ }
    return null;
  }

  function writeCache(state) {
    try {
      localStorage.setItem(CACHE_KEY, JSON.stringify({ state: state, expires: Date.now() + CACHE_TTL_MS }));
    } catch (e) { /* quota cheia, segue sem cache */ }
  }

  function resolveRegion() {
    if (regionPromise) return regionPromise;

    var cached = readCache();
    if (cached) {
      regionPromise = Promise.resolve(cached);
      return regionPromise;
    }

    regionPromise = new Promise(function (resolve) {
      if (typeof fetch !== 'function') {
        resolve({ region: FALLBACK_REGION, stateCode: null });
        return;
      }

      var ctrl = typeof AbortController === 'function' ? new AbortController() : null;
      var timeoutId = setTimeout(function () { if (ctrl) ctrl.abort(); }, GEO_TIMEOUT_MS);

      fetch(GEO_URL, ctrl ? { signal: ctrl.signal } : undefined)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          clearTimeout(timeoutId);
          var state = data && data.region_code;
          if (data && data.country_code === 'BR' && state && STATE_TO_REGION[state]) {
            writeCache(state);
            resolve({ region: STATE_TO_REGION[state], stateCode: state });
          } else {
            resolve({ region: FALLBACK_REGION, stateCode: null });
          }
        })
        .catch(function () {
          clearTimeout(timeoutId);
          resolve({ region: FALLBACK_REGION, stateCode: null });
        });
    });

    return regionPromise;
  }

  /* ---------- Custom element ---------- */

  function setText(el, value) {
    if (el) el.textContent = value;
  }

  class DeliveryEstimate extends HTMLElement {
    connectedCallback() {
      if (this._booted) return;
      this._booted = true;

      this.els = {
        skeleton: this.querySelector('[data-de-skeleton]'),
        content: this.querySelector('[data-de-content]'),
        window: this.querySelector('[data-de-window]'),
        countdown: this.querySelector('[data-de-countdown]'),
        state: this.querySelector('[data-de-state]'),
        toggle: this.querySelector('[data-de-toggle]'),
        details: this.querySelector('[data-de-details]'),
        dateOrder: this.querySelector('[data-de-date-order]'),
        dateProcessing: this.querySelector('[data-de-date-processing]'),
        dateDelivery: this.querySelector('[data-de-date-delivery]')
      };

      if (this.els.toggle && this.els.details) {
        this.els.toggle.addEventListener('click', () => {
          var expanded = this.els.toggle.getAttribute('aria-expanded') === 'true';
          this.els.toggle.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          this.els.details.hidden = expanded;
        });
      }

      resolveRegion().then((result) => {
        if (!this.isConnected) return;
        this.region = result.region;
        this.stateCode = result.stateCode;

        if (this.els.skeleton) this.els.skeleton.hidden = true;
        if (this.els.content) this.els.content.hidden = false;

        this.render();
        this._timer = setInterval(() => this.render(), TICK_MS);
      });
    }

    disconnectedCallback() {
      if (this._timer) {
        clearInterval(this._timer);
        this._timer = null;
      }
    }

    render() {
      if (!this.region) return;

      var now = new Date();
      var cd = countdown(now);
      var dates = computeDates(this.region, now, cd.isAfterCutoff);

      setText(this.els.window, 'Chegará entre ' + formatDate(dates.deliveryStart) + ' e ' + formatDate(dates.deliveryEnd));
      setText(this.els.countdown, cd.hours + 'h ' + cd.minutes + 'min');
      setText(this.els.state, this.stateCode ? ' · ' + this.stateCode : '');

      setText(this.els.dateOrder, formatDate(dates.today));
      setText(this.els.dateProcessing, formatDate(dates.processingDate));
      setText(this.els.dateDelivery, formatRange(dates.deliveryStart, dates.deliveryEnd));
    }
  }

  customElements.define('delivery-estimate', DeliveryEstimate);
})();
